module.exports = __webpack_public_path__ + "img/overview2.67f7f42b.png";